import {
  SET_BOOKING_AVAIL_DATES,
  SET_BOOKING_UNAVAIL_DATES,
  SET_BOOKING_DATE,
  SET_BOOKING_PAX,
  SET_BOOKING_VEHICLE,
  SET_BOOKING_MEETING_POINT,
  SET_BOOKING_PRICE,
  SET_BOOKING_FORM_DATA,
  SET_BOOKING_PRIMARY_DRIVER,
  SET_BOOKING_STEP,
  SET_DATE_WAS_RESET,
  TOGGLE_PROCEED_TO_PAYMENT,
  TOGGLE_AGREE_CANCELLATION_POLICY,
  REQUEST_BOOKING_INFO,
  RECEIVE_BOOKING_INFO,
  REQUEST_PRICING_INFO,
  RECEIVE_PRICING_INFO,
  REQUEST_BOOKING_STATUS,
  RECEIVE_BOOKING_STATUS,
  REQUEST_BOOKING_COMPANIONS,
  RECEIVE_BOOKING_COMPANIONS,
  SEND_BOOKING_FORM,
  SEND_BOOKING_FORM_WITH_AUTH,
  RECEIVE_BOOKING_FORM_RESPONSE,
  CLEAR_PAYMENT_DATA,
  CLEAR_BOOKING_FORM_DATA,
  SEND_COMPANION_FORM,
  RECEIVE_COMPANION_FORM_RESPONSE,
  SEND_SAVE_FOR_LATER,
  RECEIVE_SAVE_FOR_LATER_RESPONSE,
  RECEIVE_SAVED_INFO,
  REQUEST_SAVED_INFO,
  REQUEST_DELETE_SAVED_INFO,
  RECEIVE_DELETE_SAVED_INFO,
  RECEIVE_BYOR_IS_MEMBER_RESPONSE,
  REQUEST_BYOR_IS_MEMBER,
  SET_BYOR_VEHICLE_NO,
  SET_VEHICLE_NO_AND_MODEL,
  RESET_BYOR
} from '../constants/actionTypes';

import { sortBy } from 'lodash';

import { updateBookingPriceFromResponse } from '../js/utility';

const initialFormState = {
  name: '',
  ic: '',
  email: '',
  mobile: '',
  driver_name: '',
  driver_ic: '',
  driver_mobile: '',
  driver_email: '',
  driver_experience: 'Beginner',
  driver_health: '',
  driver_HealthConfirm: false,
  driver_size: 'XS',
  driver_tshirtName: '',
  companionName0: '',
  companionName1: '',
  companionName2: '',
  companionName3: '',
  companionIc0: '',
  companionIc1: '',
  companionIc2: '',
  companionIc3: '',
  companionEmail0: '',
  companionEmail1: '',
  companionEmail2: '',
  companionEmail3: '',
  companionHealth0: '',
  companionHealth1: '',
  companionHealth2: '',
  companionHealth3: '',
  companionHealthConfirm0: false,
  companionHealthConfirm1: false,
  companionHealthConfirm2: false,
  companionHealthConfirm3: false,
  companionSize0: 'XS',
  companionSize1: 'XS',
  companionSize2: 'XS',
  companionSize3: 'XS',
  companionTshirtName0: '',
  companionTshirtName1: '',
  companionTshirtName2: '',
  companionTshirtName3: ''
};

const INITIAL_STATE = {
  bookingInfo: {},
  savedInfo: null,
  bookingStatus: {},
  bookingPrice: {
    total: 0,
    parking: 0,
    price: 0,
    pricePerPax: 0,
    priceByAge: {
      adult: 0,
      child: 0
    },
    insurance: 0,
    insurancePerPax: 0,
    taxAmount: null,
    discount: 0,
    discountType: '',
    promos: []
  },
  proceedToPayment: false,
  step: 1,
  primaryDriver: true,
  availDates: [],
  unavailDates: [],
  date: '',
  pax: 0,
  selectedVehicleId: null,
  selectedVehicleName: '',
  selectedMeetingPointId: null,
  selectedMeetingPointName: '',
  vehicleWasReset: false,
  meetingPointWasReset: false,
  dateWasReset: false,
  companionResponse: {},
  companionStatus: {},
  formData: initialFormState,
  paymentData: {},
  loading: true,
  saving: false,
  saveMessage: '',
  saveUuid: '',
  error: null,
  agreeCancellationPolicy: false,
  byorIsMember: null,
  byorIsMemberLoading: false,
  byorVehicleNo: '',
  vehicleModel: '',
};

function sortInitialVehicles(vehicles) {
  const sortedVehicles = [];
  // vehicles should be an array. If empty, return empty array
  if (vehicles.length < 1) {
    return sortedVehicles;
  }
  // Push the recommended vehicle into the array first
  // Disable temporarily since is_recommended return NULL
  // sortedVehicles.push(vehicles.find(vehicle => vehicle.is_recommended));

  // Sort the rest by name
  const normalVehicles = sortBy(
    vehicles.filter(vehicle => vehicle.is_recommended === false),
    ['model']
  );
  normalVehicles.map(vehicle => sortedVehicles.push(vehicle));

  return sortedVehicles;
}

function bookingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_BOOKING_AVAIL_DATES: {
      return {
        ...state,
        availDates: action.dates
      };
    }
    case SET_BOOKING_UNAVAIL_DATES: {
      return {
        ...state,
        unavailDates: action.dates
      };
    }
    case SET_BOOKING_DATE: {
      return {
        ...state,
        date: action.date
      };
    }
    case SET_BOOKING_PAX: {
      return {
        ...state,
        pax: action.pax
      };
    }
    case SET_BOOKING_VEHICLE: {
      return {
        ...state,
        selectedVehicleId: action.id,
        selectedVehicleName: action.name,
        vehicleWasReset: action.reset
      };
    }
    case SET_BOOKING_MEETING_POINT: {
      return {
        ...state,
        selectedMeetingPointId: action.id,
        selectedMeetingPointName: action.name,
        meetingPointWasReset: action.reset
      };
    }
    case SET_BOOKING_FORM_DATA: {
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.data
        }
      };
    }
    case SET_DATE_WAS_RESET: {
      return {
        ...state,
        dateWasReset: action.bool
      };
    }
    case CLEAR_BOOKING_FORM_DATA: {
      return {
        ...state,
        savedInfo: null,
        saveUuid: '',
        formData: initialFormState
      };
    }
    case SET_BOOKING_PRIMARY_DRIVER: {
      return {
        ...state,
        primaryDriver: action.bool
      };
    }
    case SET_BOOKING_PRICE: {
      return {
        ...state,
        bookingPrice: {
          ...state.bookingPrice,
          ...action.bookingPrice
        }
      };
    }
    case SET_BOOKING_STEP: {
      return {
        ...state,
        step: action.step,
        dateWasReset: false,
        vehicleWasReset: false,
        meetingPointWasReset: false
      };
    }
    case REQUEST_BOOKING_INFO: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_BOOKING_INFO: {
      return {
        ...state,
        vehicleWasReset: false,
        meetingPointWasReset: false,
        dateWasReset: false,
        bookingInfo: {
          ...action.response,
          trip_price: action.response.booking_summary.price_summary.trip_price,
          vehicle_selection: sortInitialVehicles(
            action.response.vehicle_selection
          ),
          meeting_points: sortBy(action.response.meeting_points, ['name']),
          isByAge:
            action.response.booking_summary.price_summary.trip_price
              .price_type === 'by_age',
          isByPax:
            action.response.booking_summary.price_summary.trip_price
              .price_type === 'by_pax'
        },
        date: action.response.booking_summary.current_date,
        loading: false
      };
    }
    case REQUEST_PRICING_INFO: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_PRICING_INFO: {
      return {
        ...state,
        bookingPrice: {
          ...state.bookingPrice,
          ...updateBookingPriceFromResponse(action.response)
        },
        loading: false
      };
    }
    case SEND_BOOKING_FORM: {
      return {
        ...state,
        loading: true
      };
    }
    case SEND_BOOKING_FORM_WITH_AUTH: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_BOOKING_FORM_RESPONSE: {
      return {
        ...state,
        //loading: false,
        paymentData: action.response
      };
    }
    case TOGGLE_PROCEED_TO_PAYMENT: {
      return {
        ...state,
        proceedToPayment: action.bool
      };
    }
    case TOGGLE_AGREE_CANCELLATION_POLICY: {
      return {
        ...state,
        agreeCancellationPolicy: action.bool
      };
    }
    case CLEAR_PAYMENT_DATA: {
      return {
        ...state,
        paymentData: {}
      };
    }
    case REQUEST_BOOKING_STATUS: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_BOOKING_STATUS: {
      return {
        ...state,
        bookingStatus: action.response,
        loading: false
      };
    }
    case REQUEST_BOOKING_COMPANIONS: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_BOOKING_COMPANIONS: {
      return {
        ...state,
        companionResponse: action.response,
        companionStatus: {},
        loading: false
      };
    }
    case SEND_COMPANION_FORM: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_COMPANION_FORM_RESPONSE: {
      return {
        ...state,
        loading: false,
        companionStatus: action.response
      };
    }
    case SEND_SAVE_FOR_LATER: {
      return {
        ...state,
        loading: true,
        saving: true
      };
    }
    case RECEIVE_SAVE_FOR_LATER_RESPONSE: {
      if (action.response.uuid) {
        return {
          ...state,
          loading: false,
          saving: false,
          saveMessage: action.response.message,
          saveUuid: action.response.uuid
        };
      }
      // If response has no uuid, its an update. So don't need to update saveUuid
      return {
        ...state,
        loading: false,
        saving: false,
        saveMessage: action.response.message
      };
    }
    case REQUEST_SAVED_INFO: {
      return {
        ...state,
        savedInfo: null,
        saveMessage: '',
        saveUuid: '',
        loading: true
      };
    }
    case RECEIVE_SAVED_INFO: {
      return {
        ...state,
        savedInfo: action.response,
        loading: false
      };
    }
    case REQUEST_BYOR_IS_MEMBER: {
      return {
        ...state,
        byorIsMemberLoading: true,
        byorIsMember: null
      };
    }
    case RECEIVE_BYOR_IS_MEMBER_RESPONSE: {
      return {
        ...state,
        byorIsMember: action.response,
        byorIsMemberLoading: false
      };
    }
    case SET_BYOR_VEHICLE_NO: {
      return {
        ...state,
        byorVehicleNo: action.no
      };
    }
    case SET_VEHICLE_NO_AND_MODEL: {
      return {
        ...state,
        byorVehicleNo: action.no,
        vehicleModel: action.model
      };
    }
    case RESET_BYOR: {
      return {
        ...state,
        byorIsMember: null,
        byorIsMemberLoading: false,
        byorVehicleNo: ''
      };
    }
    default:
      return state;
  }
}

export default bookingReducer;
